module.exports = __webpack_public_path__ + "img/stamm klein.f2bb8ea6.png";